export const SPRING_CLEANING = 'spring_cleaning';
export const AFTER_REPAIR = 'after_repair';
export const DRY_CLEANING = 'dry_cleaning';
export const WINDOWS = 'windows';
export const AFTER_THE_FIRE = 'after_the_fire';
export const SEWERAGE = 'sewerage';
export const OFFICE_B2B = 'office_b2b';
export const REMAKE = 'remake';
export const CONTINUE = 'continue';
export const PER_HOUR = 'per_hour';

export const COMPLEX_TYPES = [
  SPRING_CLEANING,
  AFTER_THE_FIRE,
  SEWERAGE,
  OFFICE_B2B,
  AFTER_REPAIR,
  DRY_CLEANING,
  WINDOWS,
  REMAKE,
  CONTINUE,
  PER_HOUR
];
